import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2';

import { PermissionService } from '@app/core/auth/services/permission.service';
import { RfqService } from '@app/core/quotes';
import { ExportTemplateRfqService } from '@app/core/quotes/services/export-template-rfq.service';
import { environment } from '@app/env-service';

@Component({
  selector: 'export-template-rfq-popup-form',
  templateUrl: './export-template-rfq-popup-form.component.html',
  styleUrls: ['./export-template-rfq-popup-form.component.scss'],
})
export class ExportTemplateRfqPopupFormComponent implements OnInit {
  rfq$ :Observable<any[]>;
  rfqLoading = false;
  rfqInput$ = new Subject<string>();

  url :string = environment.url;
  formData :UntypedFormGroup;
  pageTitle :string = 'Add New Export Template Rfq';
  submitted :boolean = false;

  loading :boolean;

  fieldsTempHolder :any = [];

  public fields :Array<any> = [
    'Product Name',
    'Product URL',
    'Master SKU #',
    'Variant SKU #',
    'Alternate SKUs',
    'UPC',
    'Location Warehouse',
    'Locations',
    'Unit Cost (FIFO)',
    'Wholesale Cost',
    'Retail Cost',
    'Qty On Hand',
    'Qty Incoming',
    'Qty Available',
    'Qty Pending',
    'Re-Order Level',
    'Low Stock Alert Quantity',
    'Minimum Stock',
    'Last Month Sale Qty',
    'Product Description',
    'Product Category',
    'Product Sub Category',
    'Preferred Vendor',
    'Product Tags',
    'Product Weight',
    'Product Dimensions',
    'Shipping Weight',
    'Shipping Dimensions',
    'Box Weight',
    'Box Dimensions',
    'Carton Weight',
    'Carton Dimensions',
    'Pallet Weight',
    'Pallet Dimensions',
    'Cartons per pallet',
    'Units per pallet',
    'Units per carton',
    'Product Links',
    'Materials',
    'Link to Product Photo',
    'Link to Product Design',
    'Default Receiving Bin',
    'Product Image',
  ];

  @Input() exportTemplateRfq :any;

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    public exportTemplateRfqService :ExportTemplateRfqService,
    private toastr :ToastrService,
    private http :HttpClient,
    public rfqSvc :RfqService,
    public UserPermission :PermissionService,
  ) {}

  ngOnInit() :void {
    this.formData = this.fb.group({
      name: ['', Validators.required],
    });
    if (!this.UserPermission.can('exportUnitCost')) {
      this.fields.splice(7, 3);
    }
    if (this.exportTemplateRfq) {
      this.formData.patchValue({ name: this.exportTemplateRfq.name });
      this.formData.patchValue({ fields: this.exportTemplateRfq.fields });
      this.formData.patchValue({ type: this.exportTemplateRfq.type });
      this.fieldsTempHolder = this.exportTemplateRfq.fields;
    }

    this.loading = false;
    this.submitted = false;
  }

  private checkIfFieldIsChecked(data :any) :boolean {
    const ref = this.fieldsTempHolder.find((field) => field == data);
    if (ref == data) {
      return true;
    } else {
      return false;
    }
  }

  private onChangeFieldValue(event ?:any) :void {
    const isChecked = event.target.checked;
    const field = event.target.value;

    const index = this.fieldsTempHolder.findIndex((item) => item == field);
    if (index === -1) {
      if (isChecked) {
        this.fieldsTempHolder.push(field);
      }
    } else {
      if (!isChecked) {
        this.fieldsTempHolder.splice(index, 1);
      }
    }
  }

  save() :void {
    this.loading = true;
    this.submitted = true;
    if (this.formData.invalid) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please fill all the required fields.',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }

    const payload :any = Object.assign({}, this.formData.value);

    if (!this.fieldsTempHolder || this.fieldsTempHolder.length == 0) {
      Swal.fire({
        title: 'Form Error!',
        text: 'At least one(1) Export Field is required.',
        type: 'error',
        confirmButtonText: 'Back to Form',
      });

      return;
    }

    payload.type = 'rfq';
    payload.fields = this.fieldsTempHolder;

    if (this.exportTemplateRfq && this.exportTemplateRfq.id) {
      this.exportTemplateRfqService
        .updateTemplate(payload, this.exportTemplateRfq.id)
        .subscribe(
          (resp) => {
            this.toastr.success('Export template updated');
            this.loading = false;
            this.activeModal.close(resp);
          },
          (error) => {
            this.loading = false;
            this.toastr.error(
              'Error updating export template rfq. Please try again later or contact support.',
            );
          },
        );
    } else {
      this.exportTemplateRfqService.saveTemplate(payload).subscribe(
        (resp) => {
          this.toastr.success('New export template rfq created');
          this.loading = false;
          this.activeModal.close(resp);
        },
        (error) => {
          this.loading = false;
          this.toastr.error(
            'Error creating export template rfq. Please try again later or contact support.',
          );
        },
      );
    }
  }
}
